import cn from 'clsx';

import {Text} from '@/components/Typography';
import type {TextItemModel} from '@/types/aem';

interface TextItemListProps {
    title?: string;
    items?: TextItemModel[];
    className?: string;
}

const TextItemList = ({title, items, className}: TextItemListProps) => {
    if (!items?.length) return null;

    return (
        <div className={cn('flex w-full flex-col gap-4 text-left', className)}>
            <Text as='h2' variant='sectionTitle'>
                {title}
            </Text>
            <ul className='flex flex-col rounded-xl bg-light-silver px-4 dark:bg-orion-2'>
                {items.map((item, index) => (
                    <li
                        key={item.title ?? item.description ?? `item-${index}`}
                        className='flex flex-col border-light-gray border-b py-4 last:border-0 dark:border-orion-divider'
                    >
                        <Text variant='listTitle'>{item.title}</Text>
                        <Text variant='listText'>{item.description}</Text>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TextItemList;
